import api from './client';

export async function getSettings(): Promise<Record<string, string>> {
  return api.get<Record<string, string>>('/admin/settings');
}

export async function updateSettings(data: Record<string, string>): Promise<Record<string, string>> {
  return api.put<Record<string, string>>('/admin/settings', data);
}

export async function deleteSetting(key: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/admin/settings/${key}`);
}

export async function getMyIp(): Promise<{ ip: string }> {
  return api.get<{ ip: string }>('/admin/settings/whoami-ip');
}

export async function runBackupNow(): Promise<{ started: boolean }> {
  return api.post<{ started: boolean }>('/admin/settings/backup-now');
}
